import { ON_RESTART_GAME } from '../state-constants/stateConstants';

export const onRestartGame = (bool) => ({
  type: ON_RESTART_GAME,
  payload: bool,
});



// WEBPACK FOOTER //
// ./src/state-actions/onRestartGame.js